import styled, { css } from "styled-components";
import { colors } from "constants/colors";

interface CommonTextProps {
  fontWeight?: string; // 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal) (이외의 사이즈가 추가된다면 폰트를 android, ios에 각각 추가 해줘야 됨.)
  color?: string; // 색상 (default: colors.black)
  $textAlign?: "left" | "center" | "right" | "justify"; // 정렬 (default: left)
  textDecorationLine?: string; // 'none' | 'underline' | 'line-through' | 'underline line-through';
  width?: string | number;
  height?: string | number;
  $lineHeight?: number; // 인라인박스 높이 (default: 각 폰트 사이즈 별로 상이)
  letterSpacing?: number; // 글자 사이 간격 (default: 각 폰트 사이즈 별로 상이)
  marginTop?: number;
  marginRight?: number;
  marginLeft?: number;
  marginBottom?: number;
}

// 공통 스타일
const StyledCommonText = styled.span<CommonTextProps>`
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 400)};
  color: ${({ color }) => color || colors.black};
  text-align: ${({ $textAlign }) => $textAlign || "left"};
  text-decoration-line: ${({ textDecorationLine }) =>
    textDecorationLine || "none"};
  ${({ width }) =>
    width &&
    css`
      width: ${typeof width === "number" ? `${width}px` : width};
      display: inline-block; /* width를 주려면 inline-block 필요 */
    `}
  margin-top: ${({ marginTop }) =>
    typeof marginTop === "number" ? `${marginTop}px` : "0px"};
  margin-right: ${({ marginRight }) =>
    typeof marginRight === "number" ? `${marginRight}px` : "0px"};
  margin-left: ${({ marginLeft }) =>
    typeof marginLeft === "number" ? `${marginLeft}px` : "0px"};
  margin-bottom: ${({ marginBottom }) =>
    typeof marginBottom === "number" ? `${marginBottom}px` : "0px"};
`;

export default StyledCommonText;

/**
 * 폰트사이즈 8
 * @param $lineHeight - 인라인박스 높이 (default: 12)
 * @param letterSpacing - 글자 사이 간격 (default: -0.4)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText8 = styled(StyledCommonText)`
  font-size: 8px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "12px"};
  letter-spacing: -0.4px;
`;

/**
 * 폰트사이즈 7
 * @param $lineHeight - 인라인박스 높이 (default: 10)
 * @param letterSpacing - 글자 사이 간격 (default: -0.35)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText7 = styled(StyledCommonText)`
  font-size: 7px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "10px"};
  letter-spacing: -0.35px;
`;

/**
 * 폰트사이즈 9
 * @param $lineHeight - 인라인박스 높이 (default: 13.5)
 * @param letterSpacing - 글자 사이 간격 (default: -0.45)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText9 = styled(StyledCommonText)`
  font-size: 9px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "13.5px"};
  letter-spacing: -0.45px;
`;

/**
 * 폰트사이즈 10
 * @param $lineHeight - 인라인박스 높이 (default: 14.5)
 * @param letterSpacing - 글자 사이 간격 (default: -0.5)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 */
export const StyledText10 = styled(StyledCommonText)`
  font-size: 10px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "14.5px"};
  letter-spacing: -0.5px;
`;

/**
 * 폰트사이즈 11
 * @param $lineHeight - 인라인박스 높이 (default: 16.5)
 * @param letterSpacing - 글자 사이 간격 (default: -0.55)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText11 = styled(StyledCommonText)`
  font-size: 11px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "16.5px"};
  letter-spacing: -0.55px;
`;

/**
 * 폰트사이즈 12
 * @param $lineHeight - 인라인박스 높이 (default: 18)
 * @param letterSpacing - 글자 사이 간격 (default: -0.6)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText12 = styled(StyledCommonText)`
  font-size: 12px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "18px"};
  letter-spacing: -0.61px;
`;

/**
 * 폰트사이즈 13
 * @param $lineHeight - 인라인박스 높이 (default: 19)
 * @param letterSpacing - 글자 사이 간격 (default: -0.65)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText13 = styled(StyledCommonText)`
  font-size: 13px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "19px"};
  letter-spacing: -0.65px;
`;

/**
 * 폰트사이즈 14
 * @param $lineHeight - 인라인박스 높이 (default: 20.5)
 * @param letterSpacing - 글자 사이 간격 (default: -0.7)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText14 = styled(StyledCommonText)`
  font-size: 14px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "20.5px"};
  letter-spacing: -0.7px;
`;

/**
 * 폰트사이즈 15
 * @param $lineHeight - 인라인박스 높이 (default: 22.5)
 * @param letterSpacing - 글자 사이 간격 (default: -0.75)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText15 = styled(StyledCommonText)`
  font-size: 15px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "22.5px"};
  letter-spacing: -0.75px;
`;

/**
 * 폰트사이즈 16
 * @param $lineHeight - 인라인박스 높이 (default: 23.5)
 * @param letterSpacing - 글자 사이 간격 (default: -0.8)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 */
export const StyledText16 = styled(StyledCommonText)`
  font-size: 16px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "23.5px"};
  letter-spacing: -0.81px; // 디바이스에 따라서 글자가 한줄 아래로 떨어지는 버그가 있어서 수치 조정 (-0.8 -> -0.81)
`;

/**
 * 폰트사이즈 17
 * @param $lineHeight - 인라인박스 높이 (default: 25)
 * @param letterSpacing - 글자 사이 간격 (default: -0.85)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText17 = styled(StyledCommonText)`
  font-size: 17px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "25px"};
  letter-spacing: -0.85px;
`;

/**
 * 폰트사이즈 18
 * @param $lineHeight - 인라인박스 높이 (default: 27)
 * @param letterSpacing - 글자 사이 간격 (default: -0.9)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText18 = styled(StyledCommonText)`
  font-size: 18px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "27px"};
  letter-spacing: -0.9px;
`;

/**
 * 폰트사이즈 20
 * @param $lineHeight - 인라인박스 높이 (default: 29.5)
 * @param letterSpacing - 글자 사이 간격 (default: -1)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText20 = styled(StyledCommonText)`
  font-size: 20px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "29.5px"};
  letter-spacing: -1px;
`;

/**
 * 폰트사이즈 21
 * @param $lineHeight - 인라인박스 높이 (default: 31)
 * @param letterSpacing - 글자 사이 간격 (default: -1.05)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText21 = styled(StyledCommonText)`
  font-size: 21px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "31px"};
  letter-spacing: -1.05px;
`;

/**
 * 폰트사이즈 21
 * @param $lineHeight - 인라인박스 높이 (default: 32.5)
 * @param letterSpacing - 글자 사이 간격 (default: -1.1)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText22 = styled(StyledCommonText)`
  font-size: 22px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "32.5px"};
  letter-spacing: -1.1px;
`;

/**
 * 폰트사이즈 24
 * @param $lineHeight - 인라인박스 높이 (default: 35.5)
 * @param letterSpacing - 글자 사이 간격 (default: -1.2)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText24 = styled(StyledCommonText)`
  font-size: 24px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "35.5px"};
  letter-spacing: -1.201px;
`;

/**
 * 폰트사이즈 26
 * @param $lineHeight - 인라인박스 높이 (default: 35.5)
 * @param letterSpacing - 글자 사이 간격 (default: -1.2)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText26 = styled(StyledCommonText)`
  font-size: 26px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "38.5px"};
  letter-spacing: -1.3px;
`;

/**
 * 폰트사이즈 28
 * @param $lineHeight - 인라인박스 높이 (default: 41.5)
 * @param letterSpacing - 글자 사이 간격 (default: -1.4)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText28 = styled(StyledCommonText)`
  font-size: 28px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "41.5px"};
  letter-spacing: -1.4px;
`;

/**
 * 폰트사이즈 30
 * @param $lineHeight - 인라인박스 높이 (default: 45)
 * @param letterSpacing - 글자 사이 간격 (default: -1.5)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText30 = styled(StyledCommonText)`
  font-size: 30px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "45px"};
  letter-spacing: -1.5px;
`;

/**
 * 폰트사이즈 31
 * @param $lineHeight - 인라인박스 높이 (default: 40)
 * @param letterSpacing - 글자 사이 간격 (default: -1.55)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText31 = styled(StyledCommonText)`
  font-size: 31px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "40px"};
  letter-spacing: -1.55px;
`;

/**
 * 폰트사이즈 32
 * @param $lineHeight - 인라인박스 높이 (default: 47)
 * @param letterSpacing - 글자 사이 간격 (default: -1.6)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText32 = styled(StyledCommonText)`
  font-size: 32px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "47px"};
  letter-spacing: -1.61px; // 디바이스에 따라서 글자가 한줄 아래로 떨어지는 버그가 있어서 수치 조정 (-1.6 -> -1.61)
`;

/**
 * 폰트사이즈 35
 * @param $lineHeight - 인라인박스 높이 (default: 51.5)
 * @param letterSpacing - 글자 사이 간격 (default: -3.5)
 * @param fontWeight - 300: Light, 400/normal: Regular, 500: Medium, 700/bold: Bold (default: normal)
 * @param color - 색상 (default: #000000)
 * @param $textAlign - 정렬 (default: left)
 * @param textDecorationLine - 'none' | 'underline' | 'line-through' | 'underline line-through';
 */
export const StyledText35 = styled(StyledCommonText)`
  font-size: 35px;
  line-height: ${({ $lineHeight }) =>
    $lineHeight ? `${$lineHeight}px` : "51.5px"};
  letter-spacing: -3.5px;
`;

/**
 * #######################################################################
 * 공통 스타일 ver2
 * 제플린에 네이밍이 부여된 공통 스타일들을 정의해둠
 * 아래와 같이 사용
 * ex) Display30 인 경우
 * <StyledText.Display30>텍스트</StyledText.Display30>
 * #######################################################################
 */

// 공통 스타일 (ver2)
const StyledCommonTextV2 = styled.span<CommonTextProps>`
  color: ${({ color }) => (typeof color === "string" ? color : colors.black)};
  display: inline-block; /* width를 주려면 inline-block 필요 */
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 400)};
  text-align: ${({ $textAlign }) => ($textAlign ? $textAlign : "left")};
  text-decoration-line: ${({ textDecorationLine }) =>
    textDecorationLine ? textDecorationLine : "none"};
  ${({ width }) =>
    width &&
    css`
      width: ${typeof width === "number"
        ? `${width}px`
        : typeof width === "string"
          ? `${width}`
          : "auto"};
    `};
  ${({ height }) =>
    height &&
    css`
      height: ${typeof height === "number"
        ? `${height}px`
        : typeof height === "string"
          ? `${height}`
          : "auto"};
    `};
`;

const DisplayM30 = styled(StyledCommonTextV2)`
  font-size: 30px;
  font-style: normal;
  line-height: 45px;
  letter-spacing: -1.5px;
`;

const DisplayM24 = styled(StyledCommonTextV2)`
  font-size: 24px;
  font-style: normal;
  line-height: 42px;
  letter-spacing: -1.2px;
`;

const Display30 = styled(StyledCommonTextV2)`
  font-size: 30px;
  font-style: normal;
  line-height: 45px;
  letter-spacing: -1.5px;
`;

const Display24 = styled(StyledCommonTextV2)`
  font-size: 24px;
  font-style: normal;
  line-height: 36px;
  letter-spacing: -1.2px;
`;

const Headline17 = styled(StyledCommonTextV2)`
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: -0.85px;
`;

const Headline16 = styled(StyledCommonTextV2)`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.5px;
  letter-spacing: -0.81px;
`;

const Headline15 = styled(StyledCommonTextV2)`
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: -0.75px;
`;
const Headline13 = styled(StyledCommonTextV2)`
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: -0.75px;
`;
const Headline12 = styled(StyledCommonTextV2)`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.6px;
`;
const Body16 = styled(StyledCommonTextV2)`
  font-size: 16px;
  font-style: normal;
  line-height: 23.5px;
  letter-spacing: -0.81px;
`;

const Body15 = styled(StyledCommonTextV2)`
  font-size: 15px;
  font-style: normal;
  line-height: 23px;
  letter-spacing: -0.75px;
`;

const Body14 = styled(StyledCommonTextV2)`
  font-size: 14px;
  font-style: normal;
  line-height: 21px;
  letter-spacing: -0.7px;
`;

const Body13 = styled(StyledCommonTextV2)`
  font-size: 13px;
  font-style: normal;
  line-height: 20px;
  letter-spacing: -0.65px;
`;

const Sub12 = styled(StyledCommonTextV2)`
  font-size: 12px;
  font-style: normal;
  line-height: 18px;
  letter-spacing: -0.601px;
`;

const Sub11 = styled(StyledCommonTextV2)`
  font-size: 11px;
  font-style: normal;
  line-height: 16px;
  letter-spacing: -0.55px;
`;

export const StyledText = {
  DisplayM30,
  DisplayM24,
  Display30,
  Display24,
  Headline17,
  Headline16,
  Headline15,
  Headline13,
  Headline12,
  Body16,
  Body15,
  Body14,
  Body13,
  Sub12,
  Sub11,
};
